var Columns = /** @class */ (function () {
    function Columns(table) {
        this.table = table;
        this.columns = {};
        this.init();
    }
    Columns.prototype.init = function () {
        var self = this;
        var thead = this.table.querySelector('thead');
        var headers = thead.querySelectorAll('th');
        for (var i = 0; i < headers.length; i++) {
            var headerName = headers[i].id;
            self.columns[headers[i].id] = new ColumnTableSettings(headerName, AC.column_types[headerName], this.sanitizeLabel(headers[i]));
        }
    };
    Columns.prototype.getColumns = function () {
        return this.columns;
    };
    Columns.prototype.getColumnsMap = function () {
        var map = new Map();
        var columns = this.getColumns();
        Object.keys(columns).forEach(function (k) {
            map.set(k, columns[k]);
        });
        return map;
    };
    Columns.prototype.getColumnNames = function () {
        return Object.keys(this.columns);
    };
    Columns.prototype.get = function (column_name) {
        return this.columns.hasOwnProperty(column_name) ? this.columns[column_name] : null;
    };
    Columns.prototype.sanitizeLabel = function (header) {
        var link = header.querySelector('a');
        var label = header.innerHTML;
        // If it contains a link, we presume that it is because of sorting
        if (link) {
            var elements = link.getElementsByTagName('span');
            if (elements.length > 0) {
                label = elements[0].innerHTML;
            }
        }
        return label;
    };
    return Columns;
}());
export default Columns;
var ColumnTableSettings = /** @class */ (function () {
    function ColumnTableSettings(name, type, label) {
        this.name = name;
        this.type = type;
        this.label = label;
        this.services = {};
    }
    ColumnTableSettings.prototype.setService = function (name, service) {
        this.services[name] = service;
    };
    ColumnTableSettings.prototype.getService = function (name) {
        return this.hasService(name) ? this.services[name] : null;
    };
    ColumnTableSettings.prototype.hasService = function (name) {
        return this.services.hasOwnProperty(name);
    };
    return ColumnTableSettings;
}());
export { ColumnTableSettings };
